import { Control, FieldErrors, UseFormRegister, UseFormWatch } from "react-hook-form";
import type { Job } from "../../../models";

export interface MarkJobReadyFormInputs {
	selectedJobs: Job[];
}

export interface MarkJobReadyFormProps {
	jobs: Job[];
	initialSelectedJobs: Job[];
	onSubmit: (data: MarkJobReadyFormInputs) => void;
	onCancel: () => void;
	showCancel?: boolean;
	onSelectionChange?: (selectedJobs: Job[]) => void;
	/**
	 * If true, only show jobs from initialSelectedJobs (filter mode for popover).
	 * If false, show all jobs and use initialSelectedJobs only for checked state.
	 * @default false
	 */
	showOnlySelectedJobs?: boolean;
}

export const VALIDATION_RULES = {
	selectedJobs: {
		required: "Please select at least one job",
	},
	fieldPriority: {
		required: "Configuration is required",
	},
} as const;

export const DEFAULT_FORM_VALUES: MarkJobReadyFormInputs = {
	selectedJobs: [],
};

/**
 * ViewModel interface - exposes all data and handlers needed by the View
 */
export interface MarkJobReadyFormViewModel {
	// Form control objects from react-hook-form
	control: Control<MarkJobReadyFormInputs>;
	register: UseFormRegister<MarkJobReadyFormInputs>;
	watch: UseFormWatch<MarkJobReadyFormInputs>;
	errors: FieldErrors<MarkJobReadyFormInputs>;

	// Derived state
	jobs: Job[];
	jobsSelected: number;

	// Event handlers
	handleFormSubmit: () => void;
}
